import { ReactNode } from 'react';

import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
export type StepBoxColor = 'green' | 'blue' | 'amber';

export interface SharedStepBoxProps {
  color: StepBoxColor;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export default function SharedStepBox({
  color,
  children,
  sx,
}: SharedStepBoxProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        alignSelf: 'stretch',
        width: { xs: '100%', md: 'auto' },
        minWidth: 0,
        height: 'auto',
        minHeight: { xs: 'auto', md: 143 },
        padding: '8px 8px 8px 12px',
        boxSizing: 'border-box',
        borderRadius: '8px',
        borderLeft: (theme) =>
          `4px solid ${theme.palette.semantic.outline[color]}`,
        backgroundColor: (theme) => theme.palette.semantic.surface[color],
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
